'use client';

import * as React from 'react';
import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps
} from '@mui/material';
import styles from './tooltip.module.scss';
import { cva } from 'class-variance-authority';

const tooltipClass = cva(styles.tooltipContent, {
  variants: {
    size: {
      small: styles.tooltipSmall,
      medium: '',
      large: styles.tooltipLarge
    },
    color: {
      primary: styles.tooltipPrimary,
      secondary: styles.tooltipSecondary
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});

const tooltipArrowClass = cva('', {
  variants: {
    color: {
      primary: styles.tooltipArrowPrimary,
      secondary: styles.tooltipArrowSecondary
    }
  }
});

export type TooltipPlacement =
  | 'bottom'
  | 'bottom-end'
  | 'bottom-start'
  | 'left'
  | 'left-end'
  | 'left-start'
  | 'right'
  | 'right-end'
  | 'right-start'
  | 'top'
  | 'top-end'
  | 'top-start';

type sizeVariants = 'small' | 'medium' | 'large';

type CustomTooltipProps = {
  content: string;
  children: React.ReactNode;
  size: sizeVariants;
  color: 'primary' | 'secondary';
  placement: TooltipPlacement;
} & Partial<Pick<MuiTooltipProps, 'placement' | 'arrow' | 'enterDelay'>>;

const Tooltip: React.FC<CustomTooltipProps> = ({
  content,
  children,
  size,
  color,
  placement,
  arrow = true,
  enterDelay = 300
}) => {
  return (
    <MuiTooltip
      title={content}
      arrow={arrow}
      placement={placement}
      enterDelay={enterDelay}
      classes={{
        tooltip: tooltipClass({ size, color }),
        arrow: tooltipArrowClass({ color })
      }}
    >
      <span className={styles.tooltip}>{children}</span>
    </MuiTooltip>
  );
};

export { Tooltip };
